import React, { useEffect } from 'react';
import { RouteProps, Switch, matchPath, useLocation } from 'react-router-dom';

import { pulseScreenView } from 'pulse';

type SwitchChildProps = RouteProps & { from?: string };

/**
 * Шаблон маршрута, который Switch отрисует для pathname (тот же выбор: первый совпавший ребёнок).
 * Экран - только exact-маршрут: раскладку без exact отправит её вложенный TrackedSwitch.
 */
const getScreen = (children: React.ReactNode, pathname: string) => {
  let isFound = false;
  let screen: string | undefined;

  React.Children.forEach(children, (child) => {
    if (isFound || !React.isValidElement<SwitchChildProps>(child)) return;

    const path = child.props.path || child.props.from;
    const match = path ? matchPath(pathname, { ...child.props, path }) : null;

    if (path && !match) return;

    isFound = true;

    if (child.props.exact && match) screen = match.path;
  });

  return screen;
};

/** Switch из react-router, который при смене адреса отправляет просмотр экрана в BI Pulse */
const TrackedSwitch: React.FC = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const screen = getScreen(children, pathname);

    if (screen) pulseScreenView(screen, pathname);
    // children - статичный список маршрутов, экран меняется только со сменой адреса
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <Switch>{children}</Switch>;
};

export default TrackedSwitch;
